<div>
    <div mat-dialog-title
        class="primary-font flex justify-between border-b border-b-gray-300 zuper-dialog-header mb-0">
        <h2>{{actionSelectorOption?.title}}</h2>
        <button mat-icon-button aria-label="close dialog" (click)="closeDialog()" tabindex="-1">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div
        class="w-full max-h-25vh overflow-y-auto zuper-scrollbar primary-font font-normal text-base text-gray-700">
        <div class="relative overflow-y-auto flex flex-col space-y-4 p-4">
            <div class="flex items-start space-x-3" *ngFor="let option of actionSelectorOption?.options; let i = index;">
                <input id="{{option?.key}}" type="radio" [value]=option?.key
                    [checked]="selectedType === option?.key"
                    (click)="selectedType = option?.key"
                    class="h-4 w-4 mt-0.5 border-gray-300 text-indigo-600">
                <label for="{{option?.key}}" class="flex flex-col space-y-1 cursor-pointer">
                    <span class="font-medium text-gray-700">{{option?.optionTitle}}</span>
                    <span class="font-normal text-gray-500" *ngIf="option?.optionMessage">{{option?.optionMessage}} </span>
                </label>
            </div>
        </div>
    </div>
    <div
        class="flex justify-end border-t border-gray-300 zuper-dialog-footer primary-font font-normal text-base text-gray-700">
        <div class="flex justify-around space-x-4">
            <button type="button" (click)="closeDialog()"
                class="px-6 items-center py-2 border b-1 border-gray-300 text-black shadow-sm text-lg font-small rounded-md bg-white focus:outline-none btn-small">
                {{'close.text' | translate}}</button>
            <button (click)="confirmSelection()" [ngClass]="{'bg-primary': actionSelectorOption?.primaryActionButtonType === 'primary','bg-red-600': actionSelectorOption?.primaryActionButtonType === 'error'}"
                class="flex min-w-24 btn-small px-6 items-center py-2 border text-base b-1 shadow-sm text-white font-medium rounded-md text-white-600 focus:outline-none">
                <span class="text-white">{{actionSelectorOption?.primaryActionButtonText}}</span>
            </button>
        </div>
    </div>
</div>